import { useEffect, useState } from "react";

export const MOBILE_QUERY =
  "(max-width: 767px), " +
  "(max-width: 1023px) and (max-height: 500px) " +
  "and (pointer: coarse) and (hover: none)";

function layoutForViewport(): "mobile" | "desktop" {
  if (typeof window === "undefined") {
    return "desktop";
  }
  return window.matchMedia(MOBILE_QUERY).matches ? "mobile" : "desktop";
}

export function useResponsiveLayout(): "mobile" | "desktop" {
  const [layout, setLayout] = useState<"mobile" | "desktop">(layoutForViewport);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const syncLayout = () => setLayout(media.matches ? "mobile" : "desktop");

    syncLayout();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", syncLayout);
      return () => media.removeEventListener("change", syncLayout);
    }

    media.addListener(syncLayout);
    return () => media.removeListener(syncLayout);
  }, []);

  return layout;
}
